// extracted by mini-css-extract-plugin
export default {"sliderImageSup":"styles_sliderImageSup__G0x8X"};